import { FC, useContext } from 'react';

import SSRIcon from '@ingka/ssr-icon';
import checkmarkIcon from '@ingka/ssr-icon/paths/checkmark';
import { t } from '@onlinepayments/payments-library';

import { ServiceType } from '../../enums/ServiceType';
import { SubOrderType } from '../../enums/SubOrderType';
import DeliveryService from '../../interfaces/DeliveryService';
import { PayorderContext } from '../../PayorderContext';
import { getDeliveryDate } from '../../utils/dateTimeUtils';
import { Address } from '../toolkit';

import './CollectComponent.scss';
import OpeningHoursComponent from './OpeningHoursComponent';

interface ICollectProps {
  deliveryService: DeliveryService;
  showOpeningHours: boolean;
}

function getHeader(serviceType: ServiceType, isFullServe: boolean) {
  if (isFullServe) {
    return t('order.collect_full_serve_label');
  }

  switch (serviceType) {
    case ServiceType.ClickCollectStore:
      return t('order.collect_from_store_label');
    case ServiceType.PickupPoint:
    case ServiceType.PickupPointExternal:
      return t('order.collect_from_pick-up_point_label');
    default:
      return t('order.collect_from_label');
  }
}

const CollectComponent: FC<ICollectProps> = ({
  deliveryService: {
    isRangeOfDays,
    deliveryTimeWindows: [timeWindow],
    pickupPoint,
    serviceType,
  },
  showOpeningHours,
}) => {
  const {
    contextState: { orderDetails },
  } = useContext(PayorderContext);

  const isFullServe = orderDetails.response?.subOrderType === SubOrderType.FullServe;

  return (
    <>
      <div className="checkmark-heading">
        <div className="checkmark-circle">
          <SSRIcon paths={checkmarkIcon} />
        </div>
        <strong>{t('delivery_info_header')}</strong>
      </div>

      <div className="collect-delivery-method">
        <p className="text-bold">{getHeader(serviceType, isFullServe)}</p>
        {pickupPoint && <Address {...pickupPoint} />}
      </div>

      {pickupPoint && showOpeningHours && !!pickupPoint.openingHours && (
        <OpeningHoursComponent openingHours={pickupPoint.openingHours} />
      )}

      {timeWindow && (
        <div className="collect-delivery-method">
          <p className="text-bold">
            {t(isFullServe ? 'order.pick_up_date_label' : 'order.available_from_label')}
          </p>
          <p key={timeWindow.fromLocalDateTime}>{getDeliveryDate(timeWindow, isRangeOfDays)}</p>
        </div>
      )}
    </>
  );
};

export default CollectComponent;
